import { translations } from '@loyalty/translations';

export interface LocalizedEntity {
  i18nAttributes?: {
    [locale: string]: { [K: string]: any };
  };
}

export function getLocalizedProperty<
  E extends LocalizedEntity,
  K extends keyof NonNullable<E['i18nAttributes']>[L],
  L extends string,
>(
  entity: E | undefined,
  property: K,
  locale?: L | undefined,
): NonNullable<E['i18nAttributes']>[L][K] | undefined {
  if (!entity?.i18nAttributes) {
    return undefined;
  }

  const safeLocale = locale || 'en';
  const i18nAttributes = entity.i18nAttributes;

  const value =
    i18nAttributes?.[safeLocale]?.[property as string] ||
    i18nAttributes?.['en']?.[property as string] ||
    Object.keys(i18nAttributes || {})
      .map(lang => i18nAttributes?.[lang]?.[property as string])
      .find(val => val !== undefined && val !== null && val !== '');

  if (!value) return undefined;

  const translation: Record<string, string> = translations[safeLocale as keyof typeof translations];
  if (translation?.[value]) {
    return translation[value] as any;
  }
  const enTranslation: Record<string, string> = translations['en'];
  if (enTranslation?.[value]) {
    return enTranslation[value] as any;
  }
  const firstAvailableTranslation: Record<string, string> =
    translations[Object.keys(i18nAttributes)?.[0] as keyof typeof translations];
  if (firstAvailableTranslation?.[value]) {
    return firstAvailableTranslation[value] as any;
  }
  return value;
}
